'use strict';
const px = require('@mindmup/mapjs-core/src/util/px'),
	fontFamilies = require('@mindmup/mapjs-core/src/theme/font-families')();
module.exports = function updateNodeBubble(nodeView, nodeLayout, nodeDOM) {
	if (!nodeView || !nodeLayout || !nodeDOM) {
		throw new Error('invalid-args');
	}
	const nodeMetrics = nodeView.metrics,
		nodeTheme = nodeView.theme;
	if (nodeView.isGroup) {
		nodeDOM.style.minWidth = px(nodeLayout.width);
		nodeDOM.style.minHeight = px(nodeLayout.height);
	} else {
		nodeDOM.style.minWidth = px(nodeMetrics.bubble.width - (2 * nodeMetrics.bubble.border));
		nodeDOM.style.minHeight = px(nodeMetrics.bubble.height - (2 * nodeMetrics.bubble.border));
	}
	if (nodeTheme && nodeTheme.hasFontMultiplier) {
		nodeDOM.style.fontSize = nodeTheme.font.size + 'pt';
	} else {
		nodeDOM.style.fontSize = '';
	}
	if (nodeTheme && nodeTheme.font && nodeTheme.font.family && fontFamilies[nodeTheme.font.family]) {
		nodeDOM.style.fontFamily = fontFamilies[nodeTheme.font.family];
	} else {
		nodeDOM.style.fontFamily = '';
	}
	if (nodeTheme && nodeTheme.text && nodeTheme.text.alignment) {
		nodeDOM.style.textAlign = nodeTheme.text.alignment;
	} else {
		nodeDOM.style.textAlign = '';
	}
	nodeDOM.style.borderColor = nodeTheme?.lineColor || '';
	nodeDOM.style.borderWidth = px(nodeTheme?.lineWidth);
	nodeDOM.style.top = px(nodeLayout.y + nodeMetrics.bubble.y); // read from map layout
	nodeDOM.style.left = px(nodeLayout.x + nodeMetrics.bubble.x);  // read from map layout
	nodeDOM.style.borderRadius = px(nodeTheme.cornerRadius);
	nodeDOM.style.position = 'absolute';
	nodeDOM.style.color = nodeTheme.text.color;
	nodeDOM.style.backgroundColor = nodeTheme.backgroundColor;
	nodeDOM.style.opacity = 1;
};
